import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@mui/material";

export type SortOption = "ROOM_NUMBER" | "PATIENT_NAME";

interface PrintScheduleModalProps {
  open: boolean;
  onClose: () => void;
  onPrintPreview: () => void;
  sortBy: SortOption;
  setSortBy: (sortBy: SortOption) => void;
}

const PrintScheduleModal: React.FC<PrintScheduleModalProps> = ({
  open,
  onClose,
  onPrintPreview,
  setSortBy,
  sortBy
}) => {

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSortBy(event.target.value as SortOption);
  };


  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Patient Sorting</DialogTitle>
      <DialogContent>
        <FormControl component="fieldset">
          <FormLabel component="legend">
            How would you like to sort patients on the printed schedule?
          </FormLabel>
          <RadioGroup value={sortBy} onChange={handleChange}>
            <FormControlLabel
              value="ROOM_NUMBER"
              control={<Radio />}
              label="By Room"
            />
            <FormControlLabel
              value="PATIENT_NAME"
              control={<Radio />}
              label="Alphabetically"
            />
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} >
          Cancel
        </Button>
        <Button onClick={onPrintPreview} variant="contained" color="primary">
          Print Preview
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PrintScheduleModal;
